var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 96,
    viewBox: "0 0 150 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2838 0.44751H100.584C112.134 0.44751 121.631 9.87501 121.631 21.495V74.5025C121.631 86.055 112.134 95.55 100.584 95.55H21.2838C9.66133 95.55 0.236328 86.055 0.236328 74.5025V21.495C0.236328 9.87501 9.65883 0.44751 21.2838 0.44751Z",
    fill: "url(#paint0_linear_233_3149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2837 0.44751H100.584C106.536 0.44751 111.851 2.92751 115.679 6.89751L76.4162 49.7025C72.3037 54.2375 67.0612 56.5075 60.8962 56.5075C54.8012 56.5075 49.5587 54.24 45.4462 49.7025L6.11621 6.90001C9.94621 2.93001 15.3312 0.44751 21.2837 0.44751Z",
    fill: "url(#paint1_linear_233_3149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.628 79.3225C137.078 79.3225 149.761 66.6375 149.761 51.19C149.761 35.67 137.078 23.055 121.628 23.055C106.108 23.055 93.4932 35.67 93.4932 51.19C93.4932 66.6375 106.108 79.3225 121.628 79.3225Z",
    fill: "url(#paint2_linear_233_3149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.431 61.5575C118.791 61.5575 118.151 61.3125 117.664 60.825L108.521 51.6825C107.544 50.705 107.544 49.125 108.521 48.1475C109.499 47.17 111.079 47.17 112.056 48.1475L119.431 55.5225L133.466 41.4875C134.444 40.51 136.024 40.51 137.001 41.4875C137.979 42.465 137.979 44.045 137.001 45.0225L121.199 60.825C120.711 61.3125 120.071 61.5575 119.431 61.5575Z",
    fill: "url(#paint3_linear_233_3149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_233_3149",
    x1: 0.236328,
    y1: 48,
    x2: 121.629,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D8A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_233_3149",
    x1: 6.11621,
    y1: 28.4775,
    x2: 115.679,
    y2: 28.4775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_233_3149",
    x1: 93.4932,
    y1: 51.19,
    x2: 149.761,
    y2: 51.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8D5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_233_3149",
    x1: 107.789,
    y1: 51.155,
    x2: 137.736,
    y2: 51.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1505,
    stopColor: "#A8D5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FCF4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.adde25fc.svg";
export { ForwardRef as ReactComponent };